import { render, staticRenderFns } from "./cancel-reactivate-order.vue?vue&type=template&id=d68c2548&"
import script from "./cancel-reactivate-order.vue?vue&type=script&lang=js&"
export * from "./cancel-reactivate-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports